// @flow

import React, { Fragment, useEffect } from 'react';

import { isBrowser } from '@zapier/common-utils';

import type { Node } from 'react';

type Props = {
  children: Node,
  /**
   * Triggers the scroll to top behaviour when this changes.
   */
  value: string | number,
  shouldScrollUp: boolean,
};

/**
 * This component will scroll to the top of the page whenever the `value` prop
 * changes.
 */
const ScrollToTop = (props: Props) => {
  const { value, shouldScrollUp, children } = props;

  useEffect(() => {
    if (isBrowser() && value && shouldScrollUp) {
      window.scrollTo(0, 0);
    }
  }, [value, shouldScrollUp]);

  return <Fragment>{children}</Fragment>;
};

ScrollToTop.defaultProps = {
  shouldScrollUp: true,
};

export default ScrollToTop;
